<div class="principal-data-wrapper">

  @if (showData) {

    <div
      class="data-wrapper"
      [ngClass]="{'data-grid': isDataGrid}"
    >

      <div class="data">
        {{ data }} <span>{{ label | translate }}</span>
      </div>

      <ng-content select="[extra-data]"></ng-content>

    </div>

    @if (progress || progress === 0) {

      <ion-progress-bar [ngStyle]="{'--progress-bar-color': progressColor}" [value]="progress"></ion-progress-bar>

    }

  } @else {

    <ion-skeleton-text [animated]="true"></ion-skeleton-text>

  }

</div>
